import { Action } from '../actions'
import { InitialState, IUiState } from '../state'
import { detailView } from './detailView'
import { isExportDialogOpen } from './isExportDialogOpen'
import { screenSize } from './screenSize'
import { showConsentBanner } from './showConsentBanner'

export const ui = (
  state: IUiState = InitialState.ui(),
  action: Action
): IUiState => {
  switch (action.type) {
    default:
      return {
        ...state,
        screenSize: screenSize(state.screenSize, action),
        detailView: detailView(state.detailView, action),
        isExportDialogOpen: isExportDialogOpen(state.isExportDialogOpen, action),
        showConsentBanner: showConsentBanner(state.showConsentBanner, action),
      }
  }
}
